import { render, staticRenderFns } from "./DocumentFacts.vue?vue&type=template&id=681d5301&"
import script from "./DocumentFacts.vue?vue&type=script&lang=js&"
export * from "./DocumentFacts.vue?vue&type=script&lang=js&"
import style0 from "./DocumentFacts.vue?vue&type=style&index=0&id=681d5301&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports